import { getApi } from './index';
import { AuthStrategy } from '@lwtears/lwt-common-frontend/lib/@common/util/api-util';
import { hasAuthCookies } from 'util/auth-cookie-util';

const routePrefix = '/users/me';
const authStrategy = hasAuthCookies() ? AuthStrategy.AUTH_TOKEN : AuthStrategy.HTTP_AUTHENTICATION;

const updateUserSetting = (type: string, data: any) => {
  return getApi(authStrategy).put(`${routePrefix}/settings/${type}`, { data });
};

const putTourStep = (tour: Array<any>) => {
  return getApi(authStrategy).put(`${routePrefix}/tour`, { data: tour });
};

export { updateUserSetting, putTourStep };
